/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_MapInputs */

const en_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map`)
};

const es_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa`)
};

const fr_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte`)
};

const de_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karte`)
};

const ja_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地図`)
};

const zh_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地图`)
};

const ar_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خريطة`)
};

const id_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peta`)
};

const it_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mappa`)
};

const ru_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта`)
};

const pt_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa`)
};

const ko_val_map = /** @type {(inputs: Val_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지도`)
};

/**
* | output |
* | --- |
* | "Map" |
*
* @param {Val_MapInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_map = /** @type {((inputs?: Val_MapInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_MapInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_map(inputs)
	if (locale === "es") return es_val_map(inputs)
	if (locale === "fr") return fr_val_map(inputs)
	if (locale === "de") return de_val_map(inputs)
	if (locale === "ja") return ja_val_map(inputs)
	if (locale === "zh") return zh_val_map(inputs)
	if (locale === "ar") return ar_val_map(inputs)
	if (locale === "id") return id_val_map(inputs)
	if (locale === "it") return it_val_map(inputs)
	if (locale === "ru") return ru_val_map(inputs)
	if (locale === "pt") return pt_val_map(inputs)
	return ko_val_map(inputs)
});